import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7940b299&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=7940b299&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940b299",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7940b299')) {
      api.createRecord('7940b299', component.options)
    } else {
      api.reload('7940b299', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7940b299&scoped=true", function () {
      api.rerender('7940b299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assistantConfig/index.vue"
export default component.exports